import { Component, Input, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppSelectors } from '../../../store/app/app.selectors';
import { AvatarComponent } from '../avatar/avatar.component';
import { AsyncPipe, NgClass } from '@angular/common';
import {
  NgbDropdown,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';
import { Logout } from '@bo/ng-auth';
import { RouterLink } from '@angular/router';
import { ClearAppState } from '../../../store/app/app.actions';

@Component({
  selector: 'app-profile-dropdown',
  imports: [
    AvatarComponent,
    AsyncPipe,
    NgbDropdown,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    RouterLink,
    NgClass,
  ],
  templateUrl: './profile-dropdown.component.html',
})
export class ProfileDropdownComponent {
  readonly store = inject(Store);

  readonly userProfile$ = this.store.select(AppSelectors.userDetails);
  @Input() hasNavigationAccess: boolean | undefined;
  @Input() signUpFlow: boolean = false;
  protected liveUrl = 'https://www.paystashio.com/';

  onLogOut() {
    this.store.dispatch(new ClearAppState());
    this.store.dispatch(new Logout());
  }
}
